import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FormEmbed } from '../components/FormEmbed';
export function ResourcesV1() {
  return <div className="min-h-screen bg-[#eef4fb] font-sans text-[#1e3a5f]" data-id="element-11">
      <main data-id="element-12">
        {/* HERO SECTION */}
        <section className="py-10 md:py-14 px-4 bg-white border-b border-gray-100" data-id="element-13">
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-14">
            <div className="space-y-5" data-id="element-15">
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#4a7ab5] bg-[#eef4fb] px-3 py-1 rounded-full" data-id="element-16">
                Free Audio Resources
              </span>
              <h1 className="text-3xl md:text-4xl font-bold leading-snug text-[#1e3a5f]" data-id="element-17">
                Free hypnotherapy audio sessions
              </h1>
              <p className="text-base text-gray-500 max-w-md leading-relaxed" data-id="element-18">
                Created by Asha, a registered and multi-award-winning
                hypnotherapist, these sessions are designed to help you feel
                calmer, sleep better and navigate life with greater ease.
              </p>
              <a href="#sessions" className="inline-block bg-[#1e3a5f] text-white px-7 py-3 rounded-lg font-semibold text-sm shadow-sm hover:bg-[#162d4a] transition-colors" data-id="element-19">
                Explore the sessions
              </a>
            </div>
            <div className="flex justify-center md:justify-end" data-id="element-20">
              <div className="relative" data-id="element-21">
                <div className="absolute inset-0 bg-[#4a7ab5]/10 rounded-full transform translate-x-4 translate-y-4" data-id="element-22"></div>
                <img src="https://cdn.magicpatterns.com/uploads/jXrAyLm7PSjjzrEshZuigQ/AshaMiniShoot-6_(1).jpg" alt="Asha, registered hypnotherapist" className="relative w-80 h-80 md:w-[400px] md:h-[400px] object-cover rounded-full shadow-md border-4 border-white" style={{
                objectPosition: 'center 20%'
              }} data-id="element-23" />
              </div>
            </div>
          </div>
        </section>

        {/* VIDEO SECTION */}
        <section className="py-12 px-4 bg-[#eef4fb]" data-id="element-24">
          <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-25">
            <div data-id="element-26">
              <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-27">
                A personal introduction
              </h2>
              <p className="text-gray-500 mt-2 text-sm" data-id="element-28">
                Hear directly from Asha about what these recordings are and how
                they can help you.
              </p>
            </div>
            <div className="relative mx-auto w-full max-w-[640px] aspect-video rounded-xl overflow-hidden bg-gray-100" style={{
            boxShadow: '0 4px 28px rgba(30,58,95,0.14)'
          }} data-id="element-29">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HmUfhvAQlWU" title="A personal introduction from Asha, hypnotherapist" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-30" />
            </div>
          </div>
        </section>

        {/* RESOURCE CARDS */}
        <section id="sessions" className="py-16 px-4 bg-white" data-id="element-31">
          <div className="max-w-6xl mx-auto" data-id="element-32">
            <div className="text-center mb-10" data-id="element-33">
              <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-34">
                Choose your free session
              </h2>
              <p className="text-gray-500 mt-2 text-sm" data-id="element-35">
                Complete the short form to receive your download link.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6 items-stretch" data-id="element-36">
              {/* Card 1 — Menopause */}
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)'
            }} data-id="element-37">
                <div className="p-5 bg-[#eef4fb] border-b border-blue-50 text-center" data-id="element-38">
                  <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-39">
                    Menopause support
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-40">
                    Ease symptoms and restore emotional balance naturally.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-41">
                  <div className="flex-grow" data-id="element-42">
                    <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Menopause MP3" iframeId="inline-poXAdqeTuzz4bBBs2MV9" data-id="element-43" />
                  </div>
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-44">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-45" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Card 2 — Anxiety */}
              <div className="bg-white border border-[#4a7ab5]/30 rounded-2xl overflow-hidden flex flex-col" style={{
              boxShadow: '0 4px 20px rgba(74,122,181,0.12)'
            }} data-id="element-46">
                <div className="p-5 bg-[#eef4fb] border-b border-blue-50 text-center" data-id="element-47">
                  <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-48">
                    Anxiety to confidence
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-49">
                    Calm anxious thoughts and build lasting inner confidence.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-50">
                  <div className="flex-grow" data-id="element-51">
                    <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Anxiety MP3" iframeId="inline-anxiety-poXAdqeTuzz4bBBs2MV9" data-id="element-52" />
                  </div>
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-53">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-54" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Card 3 — Sleep */}
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)'
            }} data-id="element-55">
                <div className="p-5 bg-[#eef4fb] border-b border-blue-50 text-center" data-id="element-56">
                  <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-57">
                    Restful sleep
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-58">
                    Drift into deep, restorative sleep with this calming
                    session.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-59">
                  <div className="flex-grow" data-id="element-60">
                    <FormEmbed formId="LUc3SIG5R30MtnKlbZ7r" formName="Sleep MP3" iframeId="inline-LUc3SIG5R30MtnKlbZ7r" data-id="element-61" />
                  </div>
                  <p className="text-xs text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-62">
                    <CheckCircle2 className="w-3 h-3 flex-shrink-0" data-id="element-63" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TRUST BAND */}
        <section className="py-5 bg-[#1e3a5f] text-white text-center px-4" data-id="element-64">
          <p className="text-sm font-medium tracking-wide opacity-90" data-id="element-65">
            Registered professional hypnotherapist serving Solihull, Birmingham
            and online.
          </p>
        </section>

        {/* FINAL CTA */}
        <section className="py-14 px-4 bg-white text-center" data-id="element-66">
          <div className="max-w-xl mx-auto space-y-4" data-id="element-67">
            <h2 className="text-xl font-bold text-[#1e3a5f]" data-id="element-68">
              Ready for one to one support?
            </h2>
            <p className="text-gray-500 text-sm" data-id="element-69">
              Book a free 15 minute consultation to discuss how hypnotherapy can
              help you.
            </p>
            <a href="https://mindability-hypnotherapy.co.uk/location/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#1e3a5f] text-white px-8 py-3 rounded-lg font-semibold text-sm shadow-sm hover:bg-[#162d4a] transition-colors" data-id="element-70">
              Book a free consultation
            </a>
          </div>
        </section>
      </main>
    </div>;
}